import React, { useState } from "react";
import type { AnswerState, MatchPictureExercise } from "../../types/exercises";
import { ChoiceTile, TileState } from "./ChoiceTile";
import { SpeakButton } from "./SpeakButton";
interface MatchPictureProps {
  exercise: MatchPictureExercise;
  onAnswer: (a: AnswerState) => void;
  checked: boolean;
  speechLang: string;
}
export function MatchPicture({
  exercise,
  onAnswer,
  checked,
  speechLang
}: MatchPictureProps) {
  const [selected, setSelected] = useState<string | null>(null);
  const correctLabel = exercise.options.find(o => o.id === exercise.answer)?.label ?? "";
  const stateFor = (id: string): TileState => {
    if (checked) {
      if (id === exercise.answer) return "correct";
      if (id === selected) return "wrong";
      return "idle";
    }
    return id === selected ? "selected" : "idle";
  };
  return <div data-id="element-375" data-mp="33g9i4sd1d6kz">
      <div className="mb-6 flex items-center gap-3" data-id="element-376" data-mp="33gj84fy2zdqo">
        <SpeakButton text={exercise.prompt} lang={speechLang} data-id="element-377" data-mp="37kzba9gb8727" />
        <p className="text-2xl font-bold tracking-[-0.01em] text-ink md:text-3xl" lang="es" data-id="element-378" data-mp="2cqnt7hpnybkx">
          {exercise.prompt}
        </p>
      </div>
      <ul className="grid grid-cols-2 gap-3 md:gap-5" data-id="element-379" data-mp="27r1bow2sy96b">
        {exercise.options.map(o => <li key={o.id} data-id="element-380" data-mp="22tj3x90itzzw">
            <ChoiceTile state={stateFor(o.id)} disabled={checked} ariaLabel={checked ? o.label : `Picture option ${exercise.options.indexOf(o) + 1}`} className="w-full flex-col gap-2 p-2.5" onClick={() => {
          setSelected(o.id);
          onAnswer({
            ready: true,
            correct: o.id === exercise.answer,
            solution: `${correctLabel} = ${exercise.promptTranslation}`
          });
        }} data-id="element-381" data-mp="22uu839xvp9rj">
              <img src={o.image} alt="" className="aspect-square w-full rounded-xl border-2 border-line object-cover" loading="lazy" data-id="element-382" data-mp="2grzi1l0pqss2" />
              <span className={`text-sm ${checked ? "opacity-100" : "opacity-0"}`} aria-hidden={!checked} data-id="element-383" data-mp="39f3hlah1eewg">
                {o.label}
              </span>
            </ChoiceTile>
          </li>)}
      </ul>
    </div>;
}